import React from 'react';
import Icon from '../common/Icon';
import { useNavigate } from 'react-router-dom';

const FieldListItem = ({
  field,
  handleDestroy,
  handleCopy,
  hasValidResponses,
}) => {
  const navigate = useNavigate();
  const { required, type, name, id, width, validator, quick_edit } = field;
  const widthToString = (width) => {
    let widths = ['', 'full', 'half', 'third'];
    if ([1, 2, 3].includes(width)) return widths[width];
    return '';
  };

  return (
    <>
      <a className='edit' onClick={() => navigate(`/manage/fields/${id}`)}>
        <div className='cargo'>
          <div className='name'>{name}</div>
          <div className='meta'>
            <b>Width:</b>{' '}
            <progress
              value={width == 1 ? 100 : width == 2 ? 50 : width == 3 ? 34 : 0}
              max={100}
              title={widthToString(width)}
              style={{
                backgroundColor: '#595959',
                borderRadius: '4px',
                border: '1px solid #303030',
                height: '0.6em',
              }}
            />
            {' | '}
            <b>Type:</b> {type}
            {validator && (
              <>
                {' '}
                | <b>Validator:</b> {validator}
              </>
            )}
            {quick_edit && (
              <>
                {' '}
                |{' '}
                <span
                  className='fa-stack'
                  style={{ verticalAlign: 'top', fontSize: '0.6em' }}
                  title='Quick Edit Enabled'
                >
                  <i className='fa-regular fa-circle fa-stack-2x'></i>
                  <i className='fa-solid fa-q fa-stack-1x'></i>
                </span>
              </>
            )}
          </div>
        </div>
      </a>

      <div className={'flag' + (required ? ' required' : '')}>
        <Icon title={required ? 'Required' : 'Optional'} icon='flag' />
      </div>

      <div className='controls'>
        {hasValidResponses === undefined ? (
          <Icon icon='refresh fa-spin' title='Checking responses...' />
        ) : (
          <>
            <Icon
              className='duplicate'
              title='Copy'
              onClick={(e) => handleCopy(e, id)}
              icon='copy'
              faPrefix={'regular'}
            />
            {hasValidResponses === false && (
              <Icon
                className='destroy'
                onClick={(e) => handleDestroy(e, id)}
                icon='trash'
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default FieldListItem;
